import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_110: FaireProductEntity = {
  token: "catalog_prod_prod-110",
  type: "product",
  name: "Candle Holder - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 59.69,
  msrpDollars: 149.23,
  sku: "CA0110",
  caseSize: 12,
  material: "Cotton",
  collectionToken: "col_camp",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 24,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_book-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
